import {apiClient, getOne, createOne, updateOne, deleteOne, getAll} from "./Api";

const MODULE = 'artist';

export function getArtist(id) {
	return getOne(MODULE, id);
}

export function getArtistsByName(name) {
	return  apiClient.get(`${MODULE}?name=${name}`);
}

export function getArtistsByIds(ids) {
	return  apiClient.get(`${MODULE}?ids=${ids}`);
}

export function getArtists(searchProperty, searchQuery, maxResults) {
	return getAll(MODULE, searchProperty, searchQuery, maxResults);
}

export function createArtist(data) {
	return createOne(MODULE, data);
}

export function createArtistByName(name) {
	return createOne(MODULE, {
		name: name
	});
}
